import { render, staticRenderFns } from "./ProfileReviewsTable.vue?vue&type=template&id=2764b1f4&"
import script from "./ProfileReviewsTable.vue?vue&type=script&lang=js&"
export * from "./ProfileReviewsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2764b1f4')) {
      api.createRecord('2764b1f4', component.options)
    } else {
      api.reload('2764b1f4', component.options)
    }
    module.hot.accept("./ProfileReviewsTable.vue?vue&type=template&id=2764b1f4&", function () {
      api.rerender('2764b1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/tools/ProfileReviewsTable.vue"
export default component.exports